import { Tooltip } from '@sgme/ui';
import { FormattedMessage } from 'react-intl';

import { StopLossOrderRow } from '@/App/BulkOrder/BulkOrderTables/StopLossOrderRow.tsx';

type OrderTableProps = {
  orderIds: string[] | undefined;
  bdrId?: string;
  currencyPair?: string;
  isImportingWithNoStopLossRight?: boolean;
  tabId: string;
};

export const StopLossOrderTable = (props: OrderTableProps) => {
  const { orderIds, bdrId, currencyPair, tabId, isImportingWithNoStopLossRight = false } = props;
  if (isImportingWithNoStopLossRight) {
    return (
      <>
        <h3 className="d-flex align-items-center gap-3 my-2">
          <FormattedMessage id="stopLoss.table.title" />
        </h3>
        <div className="alert alert-discreet-warning text-start mt-1" role="alert">
          <i className="icon icon-md icon-outlined me-2">warning</i>
          <FormattedMessage id="import.warning.message" values={{ orderType: 'stop loss' }} />
        </div>
      </>
    );
  }

  return orderIds && orderIds.length > 0 ? (
    <>
      <h3 className="d-flex align-items-center gap-3 my-2">
        <FormattedMessage id="stopLoss.table.title" />
        <div className="badge badge-outline-primary rounded-pill ">{orderIds.length}</div>
      </h3>
      <table
        className="table table-sm table-bordered table-thead-bordered table-body-bordered table-striped table-hover bg-lvl1"
        data-e2e={
          bdrId === undefined || currencyPair === undefined
            ? 'stop-loss-order-table'
            : `stop-loss-order-table-${bdrId}-${currencyPair.replaceAll('/', '-')}`
        }
      >
        <thead>
          <tr className="align-middle">
            <th>
              <FormattedMessage id="table.header.status" />
            </th>

            <th>
              <FormattedMessage id="table.header.orderId" />
            </th>

            <th>
              <FormattedMessage id="table.header.bdr" />
              <Tooltip contents={'Account ID'}>
                <i className="icon icon-sm ps-2">info</i>
              </Tooltip>
            </th>
            <th>
              <FormattedMessage id="table.header.currencyPair" />
            </th>

            <th>
              <FormattedMessage id="table.header.way" />
            </th>

            <th>
              <FormattedMessage id="table.header.notional" />
            </th>

            <th>
              <FormattedMessage id="table.header.limitPrice" />
            </th>

            <th>
              <FormattedMessage id="table.header.expiry" />
            </th>

            <th>
              <FormattedMessage id="table.header.trigger" />
            </th>
          </tr>
        </thead>

        <tbody className="bg-lvl1">
          {orderIds.map((bulkOrderId) => (
            <StopLossOrderRow key={bulkOrderId} orderId={bulkOrderId} tabId={tabId} />
          ))}
        </tbody>
      </table>
    </>
  ) : null;
};
